module.exports = __webpack_public_path__ + "static/printer-558a588488c4f874215fe5b5d6cfc672.jpg";